import React from 'react';
import { Kid, User } from '../types';

interface HeaderProps {
  user: User | null;
  kids: Kid[];
  selectedKidId: string;
  onSelectKid: (kidId: string) => void;
  onOpenAdultZone: () => void;
  onOpenAddKid: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  kids,
  selectedKidId,
  onSelectKid,
  onOpenAdultZone,
  onOpenAddKid,
}) => {
  return (
    <header className="app-header">
      <div className="header-top-row">
        <div>
          <h1 className="app-title">Quest Tracker</h1>
          <p className="app-subtitle">Complete your daily adventures!</p>
        </div>
        <button
          id="btn-adult-zone"
          className="adult-zone-btn"
          onClick={onOpenAdultZone}
          title="Adult Zone (PIN protected)"
        >
          <span>🔒</span> Adult
        </button>
      </div>

      <div className="profile-row" role="tablist" aria-label="Kid Profiles">
        {kids.map((kid) => {
          const isSelected = kid.id === selectedKidId;
          return (
            <button
              key={kid.id}
              id={`profile-btn-${kid.name.toLowerCase()}`}
              className={`profile-item ${isSelected ? 'active' : ''}`}
              onClick={() => onSelectKid(kid.id)}
              role="tab"
              aria-selected={isSelected}
            >
              <div
                className="profile-avatar-circle"
                style={{
                  borderColor: isSelected ? (kid.color || '#8b5cf6') : 'transparent',
                }}
              >
                <span>{kid.avatar_emoji || '🌟'}</span>
              </div>
              <span className="profile-name">{kid.name}</span>
            </button>
          );
        })}

        <button
          id="btn-add-kid-profile"
          className="add-profile-circle"
          onClick={onOpenAddKid}
          title="Add new kid profile"
          aria-label="Add kid profile"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
      </div>
    </header>
  );
};
